import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { BackfillManualChannelSchema } from "./get-support-backfill-messages";

export const getSupportV2BackfillIntegrations = unaryRpc({
  name: "getSupportV2BackfillIntegrations" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    integrations: z.array(
      z.object({
        id: z.string(),
        channel: BackfillManualChannelSchema,
        identifier: z.string().optional(),
        available: z.boolean(),
        unavailableReason: z.string().optional(),
      }),
    ),
  }),
});

export type GetSupportV2BackfillIntegrationsOutput = z.infer<
  typeof getSupportV2BackfillIntegrations.output
>;
